import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import "./WebCommon.scss";
import { LeftArrow, LogoutIcon } from "../../../Assets/svgIcons";
import { Link } from "react-router-dom";
import { profitLossReportApi } from "../../../Services/prod/auth.service";
import moment from "moment";
import { formatCommaNumbers } from "../../../Utils/common.utils";

const ProfitLossReport = ({ profitlossData, startDate, endDate }) => {
  return (
    <div className="page_design">
      <Container>
        {/* <div className="backbtn mb-3">
          <Link to="/account"><span><LeftArrow /></span> Back</Link>
        </div> */}
        <div className="page_design_in">
          <div className="page_design_head">
            <h2>Profit & Loss Report</h2>
            {/* <button className="d-flex align-items-center btn-style">
              <span className="me-2"><LogoutIcon /></span> Export
            </button> */}
          </div>
          <div className="page_design_body">
            <div className="profit_loss_cards">
              <div className="profit_loss_card">
                <div className="profit_loss_card_in">
                  <div className="profit_loss_card_in_head">
                    <h3>Realised</h3>
                  </div>
                  <div className="profit_loss_card_in_body">
                    <ul>
                      <li>
                        <h4>Trade Summary</h4>
                        <p>{moment(startDate).format('DD MMMM YYYY')} - {moment(endDate).format('DD MMMM YYYY')}</p>
                      </li>
                      <li>
                        <h4>Gross P&L</h4>
                        <p>${formatCommaNumbers(profitlossData?.totalRealizedProfit)}</p>
                      </li>
                      <li>
                        <h4>Net P&L</h4>
                        <p>${formatCommaNumbers(profitlossData?.totalRealizedProfit)}</p>
                      </li>
                      <li>
                        <h4>Charges and Taxes (Platform fees - 2%)</h4>
                        <p>${formatCommaNumbers(profitlossData?.totalFeeAmount)}</p>
                      </li>
                      <li>
                        <h4>Total royalty received</h4>
                        <p>${formatCommaNumbers(profitlossData?.totalRoyalties)}</p>
                      </li>
                      <li>
                        <h4>ROI%</h4>
                        <p>{profitlossData?.roi}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="profit_loss_card">
                <div className="profit_loss_card_in">
                  <div className="profit_loss_card_in_head">
                    <h3>Unrealised</h3>
                  </div>
                  <div className="profit_loss_card_in_body">
                    <ul>
                      <li>
                        <h4>Trade Summary</h4>
                        <p>{moment(startDate).format('DD MMMM YYYY')} - {moment(endDate).format('DD MMMM YYYY')}</p>
                      </li>
                      <li>
                        <h4>Gross P&L</h4>
                        <p>${formatCommaNumbers(profitlossData?.totalUnrealizedProfit)}</p>
                      </li>
                      <li>
                        <h4>Net P&L</h4>
                        <p>${formatCommaNumbers(profitlossData?.totalUnrealizedProfit)}</p>
                      </li>
                      <li>
                        <h4>Charges and Taxes (Platform fees - 2%)</h4>
                        <p>${formatCommaNumbers(profitlossData?.totalFeeAmount)}</p>
                      </li>
                      <li>
                        <h4>ROI%</h4>
                        <p>{profitlossData?.roi}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {profitlossData?.symbolRealizedUnrealized.map((item, index) => <div className="profit_loss_card">
                <div className="profit_loss_card_in">
                  <div className="profit_loss_card_in_head no_bg">
                    <h3>Showing Result {index + 1} of {profitlossData?.symbolRealizedUnrealized?.length}</h3>
                  </div>
                  <div className="profit_loss_card_in_body">
                    <ul>
                   
                      <li>
                        <h4>{item?.symbol}</h4>
                        <p>{formatCommaNumbers(item?.buyQuantity)} qty</p>
                      </li>
                      <li>
                        <h4>Realized P&L</h4>
                        <p>{formatCommaNumbers(item?.realizedProfit)}</p>
                      </li>
                      <li>
                        <h4>UnRealized P&L</h4>
                        <p>{formatCommaNumbers(item?.unrealizedProfit)}</p>
                      </li>
                      <li>
                        <div className="buy_design">
                          <div className="buy_design_in">
                            <h4>Buy Avr.</h4>
                            <h5>${formatCommaNumbers(item?.buyAverage)}</h5>
                          </div>
                          <div className="buy_design_in">
                            <h4>Buy Amount</h4>
                            <h5>${formatCommaNumbers(item?.buyAmount)}</h5>
                          </div>
                        </div>
                        <div className="sell_design">
                          <div className="sell_design_in">
                            <h4>Sell Avr.</h4>
                            <h5>${formatCommaNumbers(item?.sellAverage)}</h5>
                          </div>
                          <div className="sell_design_in">
                            <h4>Sell Amount</h4>
                            <h5>${formatCommaNumbers(item?.sellAmount)}</h5>
                          </div>
                        </div>
                      </li>
                      <li>
                        <h4>Royalty</h4>
                        <p>${formatCommaNumbers(profitlossData?.symbolRoyalty[item?.symbol]) || 0}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>)}
              {/* <div className="profit_loss_card">
                <div className="profit_loss_card_in">
                  <div className="profit_loss_card_in_head no_bg">
                    <h3>Showing Result 1 of 1</h3>
                  </div>
                  <div className="profit_loss_card_in_body">
                    <ul>
                      <li>
                        <h4>BTC</h4>
                        <p>2 qty</p>
                      </li>
                      <li>
                        <h4>Gross P&L</h4>
                        <p>2000 (1.4%)</p>
                      </li>
                      <li>
                        <div className="buy_design">
                          <div className="buy_design_in">
                            <h4>Buy Avr.</h4>
                            <h5>$60,000</h5>
                          </div>
                          <div className="buy_design_in">
                            <h4>Buy Amount</h4>
                            <h5>$1,20,000</h5>
                          </div>
                        </div>
                        <div className="sell_design">
                          <div className="sell_design_in">
                            <h4>Sell Avr.</h4>
                            <h5>$60,000</h5>
                          </div>
                          <div className="sell_design_in">
                            <h4>Sell Amount</h4>
                            <h5>$1,20,000</h5>
                          </div>
                        </div>
                      </li>
                      <li>
                        <h4>Royalty</h4>
                        <p>$500</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ProfitLossReport;
